module.exports = __webpack_public_path__ + "static/ApyFinance-94ab8738994e7ae72f6e94877050262a.png";